<template>
    <!--
      Avviso di proroga temporanea della finestra utile per i Report di
      Performance InCheck: non ha una scadenza nel codice, va rimosso a mano
      (componente + chiavi i18n) quando la proroga decade.
    -->
    <aside class="w-full bg-amber-50 border-b border-amber-300 px-5 lg:px-10 py-3 flex items-start justify-center gap-3 text-gray-900">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            aria-hidden="true"
            class="w-5 flex-shrink-0 mt-px fill-current text-deep-orange-700">
            <path d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"/>
            <path d="M12,7a1,1,0,0,0-1,1v4a1,1,0,0,0,2,0V8A1,1,0,0,0,12,7Z"/>
            <path d="M12,15.5A1.25,1.25,0,1,0,13.25,16.75,1.25,1.25,0,0,0,12,15.5Z"/>
        </svg>
        <p class="text-sm leading-snug">
            {{ $t('banner.incheckReportPeriod', $store.state.locale) }}
        </p>
    </aside>
</template>
